module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/checkbox/checkbox-admin.component.css
// module id = ./src/app/admin/checkbox/checkbox-admin.component.css
// module chunks = main